import { axiosInstance, getAuthorizationHeaders } from '@/services/base';

const roleUrlString = localStorage.getItem('mainRole') === 'admin' ? `admin/requests` : `requests`;

export function postCoe(data) {
    const urlString = `users/coe/submit`;
    return axiosInstance.post(urlString, data, getAuthorizationHeaders());
}

export function approveCoe({ file, id }) {
    const urlString = `admin/coe/approve`;
    const formData = new FormData();
    formData.append('id', id);
    formData.append('file', file);
    formData.append('status', 'approved');
    return axiosInstance.post(urlString, formData, {
        headers: { ...getAuthorizationHeaders().headers, 'Content-Type': 'multipart/form-data' },
    });
}
export function updateCoe(data) {
    return axiosInstance.put(`users/coe/update`, data, getAuthorizationHeaders());
}
export function cancelCoe(data) {
    return axiosInstance.post(`users/coe/cancel`, data, getAuthorizationHeaders());
}

export function getCoeDetailsAdmin(id) {
    return axiosInstance.get(`admin/coe/get-details`, { params: { id }, ...getAuthorizationHeaders() });
}
export function getCoeDetailsEmployee(id) {
    return axiosInstance.get(`users/coe/get-details`, { params: { id }, ...getAuthorizationHeaders() });
}
export function rejectCoe({id}) {
    return axiosInstance.post(`admin/coe/reject`, { id }, getAuthorizationHeaders());
}


export function getPaginatedCoe({ filter = {}, page = 1, limit = 10, sort = { createdAt: -1 } }) {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    const urlString = `/users/coe/get-list`;
    return axiosInstance.get(urlString, {
        params: { filter: filter, limit: limit, page: page, sort },
        headers,
    });
}
export function getPaginatedCoeAdmin({ filter = {}, page = 1, limit = 10, sort = { createdAt: -1 } }) {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    const urlString = `/admin/coe/get-list`;
    return axiosInstance.get(urlString, {
        params: { filter: filter, limit: limit, page: page, sort },
        headers,
    });
}
export function getPrivateCoeUrl(id) {
    const urlString = `/users/coe/download`;
    return axiosInstance.post(urlString, { id }, getAuthorizationHeaders());
}
export function retrieveEmployeePasswordCoe(id) {
    const urlString = `/users/coe/retrieve-password`;
    return axiosInstance.post(urlString, { id }, getAuthorizationHeaders());
}

export function getPrivateCoeUrlAdmin(id) {
    const urlString = `/admin/coe/download`;
    console.log('getPrivateCoeUrl: ', id);
    return axiosInstance.post(urlString, { id }, getAuthorizationHeaders());
}
/*Admin Api Endpoints*/
export function requestProcess(data) {
    const urlString = `/process`;
    return axiosInstance.post(roleUrlString + urlString, data, getAuthorizationHeaders());
}

export function getAdminPaginatedRequestsByUser(filter, page = 1, limit = 1000) {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    const urlString = `/list`;
    return axiosInstance.get(roleUrlString + urlString, {
        params: { filter: filter, limit: limit, page: page },
        headers,
    });
}

export function requestLeaveProcess(data) {
    return axiosInstance.post('admin/leaves/process', data , getAuthorizationHeaders());
}
